<template>
  <router-view />
  <ZNotificationBase />
  <span v-if="false" class="hover:bg-accentBlue/80 hover:bg-coolGray hover:bg-textDarkGray/80 hover:bg-statusGreen/80 hover:bg-textBlack/80 hover:bg-alertRed/80"></span><!--JITで表示するためのダミークラス宣言(ZButton)-->
</template>

<script setup lang="ts">
import ZNotificationBase from './components/toast/ZNotificationBase.vue';
</script>
